import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getPickToPackTime = {
  name: "getPickToPackTime" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
